/**
 * 运营 - 其他途径批次（REQ-005 F010 前端，T-020；REQ-008 F005/F006 弹窗化改造，T-029）
 *
 * 页面结构（契约 API-014 v1.2.0，T-030 后端已实现）：
 * 1. 批次列表卡片：搜索表单置顶（商户/服务商/结算月份）+ 全字段分页表格
 *    （17 列；服务商标签与列头文案同步(AC-004-03)，增值税列头改为"增值税"，绑定字段 vatRate（T-028 契约 v1.1.0）；
 *    代理商单列已删除，改一级/二级/三级代理三列并排（T-031，REQ-009 F003 契约 v1.2.0：
 *    firstAgentName/secondAgentName/thirdAgentName，未配置显示"-"，列序在服务商之后，与商户档案列表口径一致）；
 *    底价列追加在管理费率列之后（T-037，REQ-012 F004 契约 v1.4.0：绑定 bottomRate，
 *    复用 fmt4 展示——空值"-"，0 正常显示 0.0000（存量 0 不做"-"处理），既有列全部保留））
 *    按钮区（REQ-010 F001，T-032）：搜索表单下方、表格上方左对齐——模板下载（沿用 downloadTemplate）
 *    + 导入批次（打开导入弹窗，AC-005-03；原「选择文件」改名，卡片 header 仅保留「批次列表」标题）
 * 2. 导入弹窗（el-dialog，REQ-008 F005 弹窗化 + REQ-010 F002 纵向单列重排，T-032）：
 *    内嵌 el-upload（accept=.xlsx, auto-upload=false, limit=1）→ 选中后弹窗内回显文件名（AC-005-04，独立成行）
 *    → "导入"按钮独占一行（未选文件提示"请先选择 .xlsx 文件"不发请求 AC-005-05；导入中 loading 防重复）
 *    → 导入结果在弹窗内展示（成功 N 行/失败 M 行 + 失败明细表 行号+原因，AC-005-06）
 *    → 弹窗最底部一行灰色小字精简注释（REQ-010 AC-002-02）
 *    导入成功后列表自动刷新并重置第一页（FX-T020-01，AC-005-07），弹窗保持打开由用户手动关闭（REQ-008 §9 #5）
 *
 * 边界（任务描述 + REQ-005 §9 #13）：
 * - 仅支持 .xlsx（前端先校验扩展名拦截 AC-005-08，后端 702 兜底）；单文件 ≤1000 行提示文案随迁弹窗
 * - 大文件（>1000 行）→ 弹窗内说明文字提示，后端解析超限返回 702 时展示后端 msg
 * - 覆盖导入成功后列表自动刷新展示新值
 * - 电销/面销/是否转交标志由后端按 customer_sales_relation 自动带出，运营无需关心来源（REQ-005 §9 #5）
 */
<template>
  <div class="other-channel-batch-page">
    <el-breadcrumb separator-class="el-icon-arrow-right" class="page-breadcrumb">
      <el-breadcrumb-item :to="{ path: '/oms/customerSignOrder' }">运营</el-breadcrumb-item>
      <el-breadcrumb-item>其他途径批次</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- ==================== 批次列表卡片（搜索置顶 + 按钮区在表格上方，REQ-010 F001/T-032） ==================== -->
    <el-card class="list-card" shadow="never">
      <div slot="header" class="card-header">
        <span>批次列表</span>
      </div>

      <el-form :inline="true" :model="queryForm" size="small" class="filter-form">
        <el-form-item label="商户">
          <el-input
            v-model="queryForm.merchantName"
            placeholder="商户名称，模糊匹配"
            clearable
            style="width: 200px"
            @keyup.enter.native="handleSearch"
          ></el-input>
        </el-form-item>
        <el-form-item label="服务商">
          <el-input
            v-model="queryForm.disCompanyName"
            placeholder="服务商名称，模糊匹配"
            clearable
            style="width: 200px"
            @keyup.enter.native="handleSearch"
          ></el-input>
        </el-form-item>
        <el-form-item label="结算月份">
          <el-date-picker
            v-model="queryForm.settlementMonth"
            type="month"
            value-format="yyyy-MM"
            placeholder="选择月份"
            style="width: 140px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>

      <!-- 按钮区（REQ-010 F001/T-032：搜索表单下方、表格上方，左对齐；点击行为零变化 AC-001-03） -->
      <div class="list-actions">
        <el-button size="small" :loading="templateLoading" @click="downloadTemplate">模板下载</el-button>
        <el-button size="small" type="primary" @click="openImportDialog">导入批次</el-button>
      </div>

      <el-table :data="list" border size="small" v-loading="listLoading" empty-text="暂无批次数据">
        <el-table-column label="商户" prop="merchantName" min-width="140" show-overflow-tooltip></el-table-column>
        <el-table-column label="服务商" prop="disCompanyName" min-width="140" show-overflow-tooltip></el-table-column>
        <el-table-column label="一级代理" min-width="120" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ row.firstAgentName || "-" }}</template>
        </el-table-column>
        <el-table-column label="二级代理" min-width="120" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ row.secondAgentName || "-" }}</template>
        </el-table-column>
        <el-table-column label="三级代理" min-width="120" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ row.thirdAgentName || "-" }}</template>
        </el-table-column>
        <el-table-column label="管理费率" width="110" align="right">
          <template slot-scope="{ row }">{{ fmt4(row.managementFeeRate) }}</template>
        </el-table-column>
        <!-- 底价列（T-037，REQ-012 F004 契约 v1.4.0）：紧邻管理费率列，fmt4 空值"-"、0 正常显示 -->
        <el-table-column label="底价" width="110" align="right">
          <template slot-scope="{ row }">{{ fmt4(row.bottomRate) }}</template>
        </el-table-column>
        <el-table-column label="个税税率" width="110" align="right">
          <template slot-scope="{ row }">{{ fmt4(row.individualIncomeTaxRate) }}</template>
        </el-table-column>
        <el-table-column label="增值税" width="110" align="right">
          <template slot-scope="{ row }">{{ fmt4(row.vatRate) }}</template>
        </el-table-column>
        <el-table-column label="附加税率" width="110" align="right">
          <template slot-scope="{ row }">{{ fmt4(row.additionalTaxRate) }}</template>
        </el-table-column>
        <el-table-column label="电销" min-width="100" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ row.phoneSalesName || "-" }}</template>
        </el-table-column>
        <el-table-column label="面销" min-width="100" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ row.faceSalesName || "-" }}</template>
        </el-table-column>
        <el-table-column label="是否转交电销" width="110" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="row.transferPhoneFlag === 1 ? 'warning' : 'info'" size="mini">{{ row.transferPhoneFlag === 1 ? "已转交" : "未转交" }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="是否转交面销" width="110" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="row.transferFaceFlag === 1 ? 'warning' : 'info'" size="mini">{{ row.transferFaceFlag === 1 ? "已转交" : "未转交" }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="结算时间" prop="settlementDate" width="110" align="center"></el-table-column>
        <el-table-column label="服务费" width="120" align="right">
          <template slot-scope="{ row }">{{ fmt4(row.serviceFee) }}</template>
        </el-table-column>
        <el-table-column label="管理费" width="120" align="right">
          <template slot-scope="{ row }">{{ fmt4(row.managementFee) }}</template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="page-pagination"
        background
        layout="total, sizes, prev, pager, next"
        :total="totalCount"
        :current-page.sync="queryForm.page"
        :page-size.sync="queryForm.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        @current-change="loadList"
        @size-change="handleSizeChange"
      ></el-pagination>
    </el-card>

    <!-- ==================== 导入弹窗（REQ-008 F005：原"批次导入"卡片整体迁入弹窗） ==================== -->
    <el-dialog
      title="批次导入"
      :visible.sync="importDialogVisible"
      width="640px"
      :close-on-click-modal="false"
      @closed="handleImportDialogClosed"
    >
      <!-- 弹窗内容纵向单列（REQ-010 F002/T-032，AC-002-01：统一左内边距约 24px，整体左对齐） -->
      <div class="import-dialog-content">
        <el-upload
          ref="upload"
          class="upload-demo"
          action=""
          accept=".xlsx"
          :auto-upload="false"
          :limit="1"
          :file-list="fileList"
          :on-change="handleFileChange"
          :on-remove="handleFileRemove"
          :on-exceed="handleFileExceed"
        >
          <el-button size="small" type="primary" slot="trigger">选取文件</el-button>
        </el-upload>
        <el-button
          size="small"
          type="success"
          class="import-submit-btn"
          :loading="importing"
          @click="importFile"
        >导入</el-button>

        <!-- 导入结果反馈（AC-005-06：成功 N 行 / 失败 M 行 + 失败明细；位置=导入按钮下方、底部注释之上，AC-002-04） -->
        <div v-if="importResult" class="import-result">
          <el-alert
            :type="importResult.failCount > 0 ? 'warning' : 'success'"
            :closable="false"
            show-icon
            :title="importResult.failCount > 0
              ? `导入完成：成功 ${importResult.successCount} 行，失败 ${importResult.failCount} 行`
              : `导入成功：共 ${importResult.successCount} 行`"
          ></el-alert>
          <el-table
            v-if="importResult.errors && importResult.errors.length"
            :data="importResult.errors"
            border
            size="mini"
            class="import-error-table"
          >
            <el-table-column label="Excel 行号" prop="row" width="120"></el-table-column>
            <el-table-column label="失败原因" prop="reason"></el-table-column>
          </el-table>
        </div>

        <!-- 精简注释置底（REQ-010 F002 AC-002-02，方案 2 用户 2026-09-03 拍板） -->
        <div class="import-dialog-tip">仅支持导入 .xlsx 文件，单文件 ≤1000 行；重复导入为覆盖式，服务费/管理费自动求和覆盖</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  downloadOtherChannelTemplate,
  importOtherChannelBatch,
  getOtherChannelBatchList
} from "../../api/userMG";

export default {
  name: "otherChannelBatch",
  data() {
    return {
      // ===== 列表区 =====
      queryForm: {
        merchantName: "",
        disCompanyName: "",
        settlementMonth: "",
        page: 1,
        pageSize: 20
      },
      list: [],
      totalCount: 0,
      listLoading: false,
      // ===== 导入弹窗（REQ-008 F005） =====
      importDialogVisible: false,
      templateLoading: false,
      importing: false,
      fileList: [],
      importResult: null
    };
  },
  created() {
    this.loadList();
  },
  methods: {
    // ==================== 导入弹窗 ====================
    // 打开弹窗：重置上次导入残留（文件/结果），保证每次打开为干净状态
    openImportDialog() {
      this.fileList = [];
      this.importResult = null;
      if (this.$refs.upload) {
        this.$refs.upload.clearFiles();
      }
      this.importDialogVisible = true;
    },
    // 弹窗关闭后清理（导入成功后弹窗保持打开由用户手动关闭，REQ-008 §9 #5）
    handleImportDialogClosed() {
      this.fileList = [];
      this.importResult = null;
      if (this.$refs.upload) {
        this.$refs.upload.clearFiles();
      }
    },
    // 模板下载：blob 响应，创建 <a> 触发下载
    async downloadTemplate() {
      this.templateLoading = true;
      try {
        const blob = await downloadOtherChannelTemplate();
        // 响应拦截器已处理错误（403/401 等走 error 分支提示），此处 blob 为文件流
        if (!blob || !(blob instanceof Blob)) {
          this.$message.error("模板下载失败");
          return;
        }
        const href = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = href;
        a.download = "其他途径批次导入模板.xlsx";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(href);
      } catch (e) {
        this.$message.error("模板下载失败，请重试");
      } finally {
        this.templateLoading = false;
      }
    },
    handleFileChange(file) {
      // el-upload on-change：选中文件（limit=1，取最新）；非 .xlsx 前端拦截（AC-005-08，后端 702 兜底）
      const fileName = (file && file.name) || "";
      if (fileName && !fileName.toLowerCase().endsWith(".xlsx")) {
        this.$message.warning("仅支持 .xlsx 格式文件");
        this.fileList = [];
        if (this.$refs.upload) {
          this.$refs.upload.clearFiles();
        }
        return;
      }
      this.fileList = file && file.raw ? [{ name: file.name, raw: file.raw }] : [];
      this.importResult = null;
    },
    handleFileRemove() {
      this.fileList = [];
      this.importResult = null;
    },
    handleFileExceed() {
      this.$message.warning("只能选择一个文件，请先移除已选文件");
    },
    // 导入（AC-005-05/06/07：未选文件不发请求 + 结果弹窗内展示 + 成功后列表自动刷新重置第一页）
    async importFile() {
      if (!this.fileList.length) {
        this.$message.warning("请先选择 .xlsx 文件");
        return;
      }
      const raw = this.fileList[0].raw;
      const fileName = (raw && raw.name) || "";
      if (!fileName.toLowerCase().endsWith(".xlsx")) {
        this.$message.warning("仅支持 .xlsx 格式文件");
        return;
      }
      this.importing = true;
      try {
        const formData = new FormData();
        formData.append("file", raw);
        const res = await importOtherChannelBatch(formData);
        if (res && res.code === 0) {
          const d = res.data || {};
          this.importResult = d;
          if (d.failCount > 0) {
            this.$message.warning(`导入完成：成功 ${d.successCount} 行，失败 ${d.failCount} 行`);
          } else {
            this.$message.success(`导入成功 ${d.successCount} 行`);
          }
          // 清空已选文件 + 列表自动刷新展示新值（覆盖导入，FX-T020-01 重置第一页）
          // 弹窗保持打开展示结果，由用户手动关闭（REQ-008 §9 #5）
          this.fileList = [];
          if (this.$refs.upload) {
            this.$refs.upload.clearFiles();
          }
          this.queryForm.page = 1;
          this.loadList();
        } else {
          // 702（空文件/非 xlsx/解析失败/无有效数据/超行数上限/重复上传）→ 展示后端 msg
          this.$message.error((res && res.msg) || "导入失败");
        }
      } catch (e) {
        this.$message.error("导入失败，请重试");
      } finally {
        this.importing = false;
      }
    },

    // ==================== 列表区 ====================
    async loadList() {
      this.listLoading = true;
      try {
        const params = {
          page: this.queryForm.page,
          pageSize: this.queryForm.pageSize
        };
        if (this.queryForm.merchantName) {
          params.merchantName = this.queryForm.merchantName.trim();
        }
        if (this.queryForm.disCompanyName) {
          params.disCompanyName = this.queryForm.disCompanyName.trim();
        }
        if (this.queryForm.settlementMonth) {
          params.settlementMonth = this.queryForm.settlementMonth;
        }
        const res = await getOtherChannelBatchList(params);
        if (res && res.code === 0) {
          const d = res.data || {};
          this.list = d.items || [];
          this.totalCount = d.totalCount || 0;
        } else {
          this.$message.error((res && res.msg) || "列表加载失败");
        }
      } catch (e) {
        this.$message.error("列表加载失败");
      } finally {
        this.listLoading = false;
      }
    },
    handleSearch() {
      this.queryForm.page = 1;
      this.loadList();
    },
    handleReset() {
      this.queryForm = {
        merchantName: "",
        disCompanyName: "",
        settlementMonth: "",
        page: 1,
        pageSize: 20
      };
      this.loadList();
    },
    handleSizeChange() {
      this.queryForm.page = 1;
      this.loadList();
    },

    // ==================== 展示工具 ====================
    // 金额/比例按 4 位小数展示（AC-010-02/AC-006-01；BigDecimal 原样返回，toFixed(4) 展示，空值"-"）
    fmt4(val) {
      if (val === null || val === undefined || val === "") {
        return "-";
      }
      const n = Number(val);
      return isNaN(n) ? "-" : n.toFixed(4);
    }
  }
};
</script>

<style scoped>
.other-channel-batch-page {
  padding: 10px;
}
.page-breadcrumb {
  margin-bottom: 14px;
}
.list-card {
  margin-bottom: 14px;
}
.card-header {
  display: flex;
  align-items: center;
}
/* 按钮区（REQ-010 F001）：搜索表单下方、表格上方，左对齐 */
.list-actions {
  margin: 8px 0 12px;
}
/* 弹窗内容纵向单列（REQ-010 F002）：统一左内边距约 24px */
.import-dialog-content {
  padding-left: 24px;
}
.import-dialog-tip {
  margin-top: 12px;
  color: #909399;
  font-size: 12px;
  line-height: 1.6;
}
.upload-demo {
  display: block;
}
.import-submit-btn {
  margin-top: 12px;
}
.import-result {
  margin-top: 12px;
}
.import-error-table {
  margin-top: 8px;
}
.filter-form {
  margin-bottom: 4px;
}
.page-pagination {
  margin-top: 12px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/views/oms/otherChannelBatch.vue